/**
 * A very small store — state, a setter that merges, and listeners — so the
 * ported chest state (Blockari's zustand stores) reads the same without React.
 */
export interface Store<T extends object> {
  getState(): T;
  setState(patch: Partial<T>): void;
  subscribe(fn: (s: T) => void): () => void;
}

export function createStore<T extends object>(init: T): Store<T> {
  let state = init;
  const listeners = new Set<(s: T) => void>();
  return {
    getState: () => state,
    setState(patch) {
      state = { ...state, ...patch };
      for (const fn of listeners) fn(state);
    },
    subscribe(fn) {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
  };
}
